// Modules
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

export const DefaultTooltip = ({ text, placement = 'top', delay = { show: 250, hide: 100 }, children }) => {
  return (
    <OverlayTrigger placement={placement} delay={delay} overlay={<Tooltip>{text}</Tooltip>}>
      {children}
    </OverlayTrigger>
  );
};

export default DefaultTooltip;
